var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5449 12.4136L11.394 18.5645C9.8584 20.1084 7.7998 19.9673 6.47998 18.6309C5.14355 17.311 5.01074 15.2607 6.55469 13.7168L14.98 5.2832C15.8599 4.40332 17.188 4.2207 18.0596 5.09229C18.9395 5.97217 18.7485 7.29199 17.8687 8.17188L9.56787 16.4893C9.23584 16.8213 8.8374 16.73 8.60498 16.5059C8.38916 16.2734 8.29785 15.8833 8.62988 15.543L14.4155 9.75732C14.7393 9.43359 14.7559 8.95215 14.4404 8.63672C14.125 8.32959 13.6436 8.33789 13.3198 8.66162L7.50928 14.4805C6.57959 15.4102 6.62109 16.8379 7.44287 17.668C8.33936 18.5645 9.70068 18.5396 10.6304 17.6099L18.981 9.25928C20.6328 7.60742 20.5747 5.43262 19.1221 3.97168C17.6943 2.55225 15.4863 2.46094 13.8345 4.11279L5.34277 12.6128C3.20117 14.7544 3.34229 17.8506 5.30127 19.8096C7.26025 21.7686 10.3564 21.9097 12.5063 19.7681L18.6987 13.5757C19.0142 13.2686 19.0142 12.6958 18.6904 12.397C18.3833 12.0649 17.8687 12.0981 17.5449 12.4136Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcon);
export default __webpack_public_path__ + "static/media/clipIcon.e88cc634.svg";
export { ForwardRef as ReactComponent };